import { css } from 'styled-components';

import { media } from '../shared/core/styles';
import { BaseStyled } from '../unmanaged/styles/BaseStyled';
import { BaseStyledStyling } from '../unmanaged/styles/BaseStyledStyling';

/**
 * Brand-agnostic homepage content scaffolding: grid structure, breakpoints,
 * column rules and the contentBlock layout. This layer only defines STRUCTURE
 * and consumes brand values via CSS custom properties (with neutral fallbacks),
 * so a brand that only composes the base still renders sensibly.
 *
 * Each per-brand wrapper (`HomepageWrapper.<brand>.styles.ts`) imports this,
 * so webpack dedupes it into a shared chunk while the brand-specific values
 * ship in separate, lazily-loaded chunks.
 */
export const baseContentStyling = css`
  ${BaseStyledStyling.BoxSizingBorder}
  ${BaseStyled.Banner}

  ${({ theme }) => css`
    :where([class*='row--height'], .row[data-height]) {
      --ai-icon-z-index: 100;

      grid-template-rows: auto;
      grid-template-columns: 1fr;

      :where(.col) {
        --contentBlock-aspect-ratio: calc(
          (var(--row-width, 768) / var(--col-count, 1)) / var(--row-height, 768)
        );

        grid-area: auto;
      }

      @media ${media(theme).greaterThan('sm')} {
        grid-template-columns: repeat(12, 1fr);

        :where(.col:first-child:last-child) {
          grid-area: 1 / 1 / 1 / -1;
        }

        :where(.col:first-child:nth-last-child(2n)) {
          &,
          ~ .col {
            --col-count: 2;

            grid-area: 1 / auto / auto / span 6;
          }
        }

        :where(.col:first-child:nth-last-child(3n)) {
          &,
          ~ .col {
            --col-count: 3;

            grid-area: 1 / auto / auto / span 4;
          }
        }

        :where(.col:first-child:nth-last-child(4n)) {
          &,
          ~ .col {
            --col-count: 4;

            grid-area: 1 / auto / auto / span 3;
          }
        }
      }
    }

    .contentBlock-body-link {
      margin: 0 !important;
      line-height: 1.1 !important;
    }
  `}
`;
